/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import PackageButton from 'ui/components/PackageButton.vue';
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import Badge from 'shared/ui/components/Badge.vue';
import PackageDetails from 'ui/components/PackageDetails.vue';

/**
 * Marketplace specific component to show a table of installed packages for the given event.
 *
 * @example
 * InstalledModules(:packages="installedPackages" :event="event" :orgId="orgId")
 *
 * @vue-prop {Object[]} packages the list of installed packages
 * @vue-prop {Object} current event object
 * @vue-prop {String} orgId the ID of the organization
 *
 * @category ui.components
 * @exports InstalledModules
 * @component
 */
const __vue_script__ = {
    name: 'InstalledModules',

    components: { PackageButton, DropdownMenu, Badge, PackageDetails },

    props: {
        modules: {
            type: Array,
            required: true
        },

        libs: {
            type: Array,
            required: true
        },

        event: {
            type: Object,
            required: true
        },

        orgId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            showLibs: false
        };
    },

    computed: {
        updatableModules() {
            return this.modules.filter(m => m.update).length;
        },

        updatableLibs() {
            return this.libs.filter(m => m.update).length;
        }
    },

    methods: {
        /**
         * Checks if we have to show the given package's update button or not
         *
         * @param {Object} pkg the package to check
         *
         * @returns {Boolean} if we have to display the update button or not
         */
        showUpdateButton(pkg) {
            if (pkg.is_critical) {
                return pkg.update !== pkg.patch;
            }

            return Boolean(pkg.update);
        },

        /**
         * Checks if we have something to show in the dropdown
         *
         * @param {Object} pkg the package to check
         *
         * @returns {Boolean} if we have to display the update button or not
         */
        showDropDownBtn(pkg) {
            return Boolean(pkg.can_be_uninstalled);
        },

        /**
         * Opens the details of the given package in a modal
         *
         * @param {Object} pgk the package to see the details of
         */
        openDetails(pkg) {
            const params = {
                pkgName: pkg.name,
                event: this.event
            };

            this.$modal.show(PackageDetails,
                { params },
                {
                    classes: 'medium',
                    height: 'auto',
                    reset: true
                }
            );
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"installed-modules"},[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item",class:{active: !_vm.showLibs}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.showLibs = false}}},[_vm._v(_vm._s(_vm.$t('marketplace.package.modules'))),(_vm.updatableModules > 0)?_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.updatableModules))]):_vm._e()],1)]),_c('li',{staticClass:"nav-item",class:{active: _vm.showLibs}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.showLibs = true}}},[_vm._v(_vm._s(_vm.$t('marketplace.package.libraries'))),(_vm.updatableLibs > 0)?_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.updatableLibs))]):_vm._e()],1)])]),_c('div',{staticClass:"tabs"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLibs),expression:"!showLibs"}],staticClass:"tab"},[(_vm.updatableModules > 0)?_c('package-button',{staticClass:"update-all",attrs:{"eventId":_vm.event.id,"orgId":_vm.orgId,"context":"installed-modules","type":"marketplace"}}):_vm._e(),_vm._t("search-modules"),_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"table-striped"},[_c('tbody',_vm._l((_vm.modules),function(pkg){return _c('tr',{key:pkg.name},[_c('td',{staticClass:"name"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.openDetails(pkg)}}},[_vm._v(_vm._s(pkg.title || pkg.name))]),(pkg.deprecated)?_c('badge',[_vm._v(_vm._s(_vm.$t('marketplace.package.deprecated')))]):_vm._e()],1),_c('td',{staticClass:"version"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(pkg.installedVersion))])]),_c('td',{staticClass:"actions"},[(pkg.is_critical)?_c('package-button',{attrs:{"module":pkg,"eventId":_vm.event.id,"orgId":_vm.orgId,"type":"critical","context":"installed-modules"}}):_vm._e(),(_vm.showUpdateButton(pkg))?_c('package-button',{attrs:{"module":pkg,"eventId":_vm.event.id,"orgId":_vm.orgId,"show-update-version":true,"context":"installed-modules"}}):_vm._e(),(_vm.showDropDownBtn(pkg))?_c('dropdown-menu',[_vm._t("default",null,{"module":pkg})],2):_vm._e()],1)])}),0)])])],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLibs),expression:"showLibs"}],staticClass:"tab"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.$t('marketplace.package.libraries_warn')))]),(_vm.updatableLibs > 0)?_c('package-button',{staticClass:"update-all",attrs:{"eventId":_vm.event.id,"orgId":_vm.orgId,"context":"installed-modules","type":"libs"}}):_vm._e(),_vm._t("search-libraries"),_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"table-striped"},[_c('tbody',_vm._l((_vm.libs),function(lib){return _c('tr',{key:lib.name},[_c('td',{staticClass:"name"},[_vm._v(_vm._s(lib.name)),(lib.deprecated)?_c('badge',[_vm._v(_vm._s(_vm.$t('marketplace.package.deprecated')))]):_vm._e()],1),_c('td',{staticClass:"version"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(lib.installedVersion))])]),_c('td',{staticClass:"actions"},[(lib.is_critical)?_c('package-button',{attrs:{"module":lib,"eventId":_vm.event.id,"orgId":_vm.orgId,"type":"critical","context":"installed-modules"}}):_vm._e(),(_vm.showUpdateButton(lib))?_c('package-button',{attrs:{"module":lib,"eventId":_vm.event.id,"orgId":_vm.orgId,"show-update-version":true,"context":"installed-modules"}}):_vm._e(),(_vm.showDropDownBtn(lib))?_c('dropdown-menu',[_vm._t("default",null,{"module":lib})],2):_vm._e()],1)])}),0)])])],2)])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InstalledModules.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__